<template>
   <v-container>
      <v-row>
        <v-col cols="12">
          <h1 class="mb-4">Codesnippets - API</h1>
          <CodeSnippets />
        </v-col>
      </v-row>
   </v-container>
</template>

<script>
import CodeSnippets from '@/components/CodeSnippets'

export default {
  name: 'Api',
  components: {
    CodeSnippets
  }
}
</script>

<style scoped>
</style>
